import {
  Avatar as MuiAvatar,
  AvatarProps as MuiAvatarProps,
} from "@mui/material";
import React from "react";
import { User, Users } from "react-feather";
import { User as AmtUser } from "../modules/authentication/domain";
import { InitialsAvatar } from "./InitialsAvatar";

const AvatarFallback: React.FC<{
  user?: AmtUser;
  size?: number;
  isGroup?: boolean;
}> = ({ user, size = 40, isGroup = false }) => {
  return user ? (
    <InitialsAvatar user={user} size={size} />
  ) : isGroup ? (
    <Users size={16} />
  ) : (
    <User size={16} />
  );
};

export const Avatar: React.FC<
  MuiAvatarProps & { user?: AmtUser; size?: number; isGroup?: boolean }
> = ({ user, size, isGroup, children, sx = [], ...props }) => {
  return (
    <MuiAvatar
      {...props}
      sx={[
        {
          backgroundColor: "shades.greyUltimateLight",
          borderWidth: children || props.src ? "0px" : "1px",
          borderStyle: "solid",
          borderColor: "white",
          color: "shades.grey",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children ?? <AvatarFallback user={user} size={size} isGroup={isGroup} />}
    </MuiAvatar>
  );
};
